import { Transaction, VisibleColumnSpec } from "@/types";

export const DEFAULT_ORDER_TRANSACTION_COLUMN: VisibleColumnSpec<Transaction, "price">[] = [
  "transactionDate",
  "status",
  "sellerCompanyId",
  "buyerCompanyId",
  "price",
  "amount",
  { id: "transactionClosed", breakpoint: "mantine-visible-from-xs" },
];
